import * as stylex from "@stylexjs/stylex";
import {
  breakpoints,
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export const onePagerLayout = stylex.create({
  grid: {
    display: "grid",
    gridTemplateColumns: {
      default: "minmax(0, 1.35fr) minmax(0, 1fr)",
      [breakpoints.playCompact]: "1fr",
    },
    gap: spacing.space14,
    flex: 1,
    alignItems: "stretch",
    order: { default: null, [breakpoints.playCompact]: 2 },
  },
  card: {
    minWidth: 0,
    paddingBlock: spacing.space16,
    paddingInline: spacing.space20,
    borderRadius: radii.large,
    backgroundColor: colors.playPaper,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor:
      "color-mix(in srgb, var(--softmax-color-play-ink) 14%, transparent)",
  },
  cardNote: {
    fontFamily: fonts.sans,
    fontSize: fontSizes.caption,
    fontWeight: 400,
    color: colors.playMuted,
  },
  headingText: {
    margin: 0,
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    letterSpacing: "inherit",
  },
});
